
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';

import cancelled from '../../../images/boat/cancelled.gif'
const bookingFailed = "https://png.pngtree.com/svg/20170320/payment_failed__304515.png"

export const ErrorModal = (props, Status) => {
    return (
        <div className="delete-modal">
            <Modal isOpen={props.isOpen}   className="bookingmodal">
                <ModalHeader toggle={false} style={{ borderBottom: " 0 none" }}></ModalHeader>
                <ModalBody style={{ padding: "0 0 0 8rem" }}>
                    <div>
                    <img src={bookingFailed} style={{ width: '15vh' }} />
                    </div>
                   <div  style={{padding: "0 2rem"}}><b>TTDC</b></div>
                   <span style={{marginLeft:"-1rem"}}>   Something went wrong.. Please try again !
                        </span>
                </ModalBody>
                <ModalFooter style={{ borderTop: " 0 none" }}>
                    <button style={{ backgroundColor: "#1C4E9A", border: "none", color: "white", padding: "5px" }} className="px-3" onClick={props.onClick}>OK</button>
                </ModalFooter>
            </Modal>
        </div>
    )
}